/* Scoped native-footer accordion; no forms, network, cart or checkout handlers. */
if (!customElements.get('th-footer-preview')) {
  customElements.define('th-footer-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelectorAll('[data-footer-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const open = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(open));
          button.closest('.footer-group').classList.toggle('is-open', open);
          button.querySelector('[data-footer-indicator]').textContent = open ? '−' : '+';
        }, {signal: this.controller.signal});
      });
      const main = this.querySelector('.footer-main');
      const discover = this.querySelector('.discover-area');
      const community = this.querySelector('.community');
      const mobile = window.matchMedia('(max-width: 740px)');
      const positionCommunity = () => {
        const parent = mobile.matches ? main : discover;
        if (parent && community && community.parentElement !== parent) parent.appendChild(community);
      };
      positionCommunity();
      mobile.addEventListener('change', positionCommunity, {signal: this.controller.signal});
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
